module.exports = __webpack_public_path__ + "static/img/button13.7d8ad01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button13.png
// module id = x9gn
// module chunks = 4